import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';
import axios from '../../axios.js';

import '../Resources/dashboard.css';
import Navbar from './navbar.js';
import Sidebar from './sidebar.js';
//import Newcrm_createteam from './newcrm_createteam.js';
import moment from 'moment/moment';
//import Create_customer from '../create_customer';

import {useRef as useref} from 'react';
import {useReactToPrint} from 'react-to-print';

//EXCEL DOWNLOAD IMPORT
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
//import Newcrm_addcustomer from './newcrm_addcustomer.js';
//import Newcrm_createlead from './newcrm_createlead.js';



function Loancrm_customerslist(){

  
      //Report Print Function
      const componentRef = useref();
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });
  

    
 // Function to download the data as an Excel file
 /*const downloadExcel = () => {
  // Convert JSON data to Excel worksheet
  const worksheet = XLSX.utils.json_to_sheet(data);
  
  // Create a new workbook and add the worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  
  // Convert the workbook to a binary array
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  
  // Create a Blob from the binary data and trigger a download
  const excel_data = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(excel_data, "data.xlsx");
};*/


  //console.log
  
 //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logtype=sessionStorage.getItem("logType00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");



{/* CUSTOMERS TABLE COLUMNS MANAGEMENT VARIABLES START */}
const[cd_col1_val,setcd_col1_val] = useState(0);//column1
const[cd_col2_val,setcd_col2_val] = useState(0);//column2
const[cd_col3_val,setcd_col3_val] = useState(0);//column3
const[cd_col4_val,setcd_col4_val] = useState(0);//column4
const[cd_col5_val,setcd_col5_val] = useState(0);//column5
const[cd_col6_val,setcd_col6_val] = useState(0);//column6
const[cd_col7_val,setcd_col7_val] = useState(0);//column7
const[cd_col8_val,setcd_col8_val] = useState(0);//column8
const[cd_col9_val,setcd_col9_val] = useState(0);//column9
const[cd_col10_val,setcd_col10_val] = useState(0);//column10
const[cd_col11_val,setcd_col11_val] = useState(0);//column11
const[cd_col12_val,setcd_col12_val] = useState(0);//column12
const[cd_col13_val,setcd_col13_val] = useState(0);//column13
const[cd_col14_val,setcd_col14_val] = useState(0);//column14
const[cd_col15_val,setcd_col15_val] = useState(0);//column15
const[cd_col16_val,setcd_col16_val] = useState(0);//column16
const[cd_col17_val,setcd_col17_val] = useState(0);//column17
const[cd_col18_val,setcd_col18_val] = useState(0);//column18

//Variables
const[data,setData] = useState([]);//SetData Variable

//Error Variable
const[errorvar,seterrorvar] = useState();


//FILTER VARIABLES
const[filter_val,setfilter_val] = useState(0);

const[filter_lead_stage,setfilter_lead_stage] = useState(); const updatefilter_lead_stage = (event) => { setfilter_lead_stage(event.target.value);}; const[filter_lead_stage_er,setfilter_lead_stage_er]=useState();
const[filter_customer_name,setfilter_customer_name] = useState(); const updatefilter_customer_name = (event) => { setfilter_customer_name(event.target.value);}; const[filter_customer_name_er,setfilter_customer_name_er]=useState();
const[filter_email,setfilter_email] = useState(); const updatefilter_email = (event) => { setfilter_email(event.target.value);}; const[filter_email_er,setfilter_email_er]=useState();
const[filter_contact,setfilter_contact] = useState(); const updatefilter_contact = (event) => { setfilter_contact(event.target.value);}; const[filter_contact_er,setfilter_contact_er]=useState();
const[filter_lead_date,setfilter_lead_date] = useState('1970-01-01'); const updatefilter_lead_date = (event) => { setfilter_lead_date(event.target.value);}; const[filter_lead_date_er,setfilter_lead_date_er]=useState();
const[filter_lead_status,setfilter_lead_status] = useState(); const updatefilter_lead_status = (event) => { setfilter_lead_status(event.target.value);}; const[filter_lead_status_er,setfilter_lead_status_er]=useState();
const[filter_loan_requirement,setfilter_loan_requirement] = useState(); const updatefilter_loan_requirement = (event) => { setfilter_loan_requirement(event.target.value);}; const[filter_loan_requirement_er,setfilter_loan_requirement_er]=useState();
const[filter_source,setfilter_source] = useState(); const updatefilter_source = (event) => { setfilter_source(event.target.value);}; const[filter_source_er,setfilter_source_er]=useState();

/*const[filter_remarks,setfilter_remarks] = us_remarks(); const updatefilter_remarks = (event) => { setfilter_remarks(event.target.value);}; const[filter_remarks_er,setfilter_remarks_er]=us_remarks();
*/
//Variables for pagination
const [currentPage, setCurrentPage] = useState(1);
const [pageNumber, setpageNumber] = useState(1);

useEffect(()=>{
   
  getData();
  
  },[])
 
 
    
//******************* GET CUSTOMERS DATA FUNCTION START  ********************//
function getData(){
 

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))){
 

   const $filter_lead_stage = filter_lead_stage; const $filter_customer_name = filter_customer_name; const $filter_email = filter_email; const $filter_contact = filter_contact; const $filter_lead_date = filter_lead_date;
   const $filter_lead_status = filter_lead_status; const $filter_loan_requirement = filter_loan_requirement; const $filter_source = filter_source;

 axios.post("loancrm-get-leads-list", {
   Log_id:logid,
   Token:token,
 //  Busy_id:busyid,
 //  Counter_id:counterid,
   Sn_start :0,
   Sn_end :0,
   Sn_total :0,
   Sn_limit :0,
   Filter_val : filter_val,
   Filter_lead_stage : $filter_lead_stage,
   Filter_customer_name : $filter_customer_name,
   Filter_email : $filter_email,
   Filter_contact : $filter_contact,
   Filter_lead_date : $filter_lead_date,
   Filter_lead_status : $filter_lead_status,
   Filter_loan_requirement : $filter_loan_requirement,
   Filter_source : $filter_source,
   
   //Code Edits for pagination
   'page' : pageNumber


   })
 .then((response) => {


  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");

     window.location.replace("/");
  }

  //Success Data Fetched
  if(response.data.successvar==1){
   //Setting Data
   setData(response.data.data.data);
  
  }

  //FILTER DATA
  //Validation Errors
  if(response.data.validatorerror){
  //  setfilter_lead_stage_er(response.data.validatorerror.Filter_lead_stage);
    setfilter_customer_name_er(response.data.validatorerror.Filter_customer_name);
    setfilter_email_er(response.data.validatorerror.Filter_email);
    setfilter_contact_er(response.data.validatorerror.Filter_contact);
    setfilter_lead_date_er(response.data.validatorerror.Filter_lead_date);
    setfilter_lead_status_er(response.data.validatorerror.Filter_lead_status);
    setfilter_loan_requirement_er(response.data.validatorerror.Filter_loan_requirement);
    setfilter_source_er(response.data.validatorerror.Filter_source);
  //  setfilter_remarks_er(response.data.validatorerror.Filter_remarks);
   
  }

  //Data Violation
  if(response.data.error==102){ 
  
  //  setfilter_lead_stage_er(response.data.filter_lead_stage_er);
    setfilter_customer_name_er(response.data.filter_customer_name_er);
    setfilter_email_er(response.data.filter_email_er);
    setfilter_contact_er(response.data.filter_contact_er);
    setfilter_lead_date_er(response.data.filter_lead_date_er);
    setfilter_lead_status_er(response.data.filter_lead_status_er);
    setfilter_loan_requirement_er(response.data.filter_loan_requirement_er);
    setfilter_source_er(response.data.filter_source_er);
  //  setfilter_remarks_er(response.data.filter_remarks_er);


  }


  //Cannot Fetch Data
  else{
   seterrorvar("Cannot Fetch Data !");
  }
 
 
 });
 
 }
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");


   window.location.replace("/");
 
  }
 
 }
  
 //******************* GET CUSTOMERS DATA FUNCTION END  ********************//


 

//ERROR VARIABLES 
const[eerror_msg,seteerror_msg]=useState();
 

  

 
//******************* DELETE CUSTOMER FUNCTION START ********************//
function deletecustomer(){

  const custId=sessionStorage.getItem("DEditId00");

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))&&((custId!=null)||(custId!=" "))){
 
 axios.post("newcrm-delete-customer", {
   Log_id:logid,
   Token:token,
   Edit_id:custId,
 })
 .then((response) => {

  //console.log(response);

  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("DEditId00");

     window.location.replace("/");
  }

  //Counter Deleted Successfully
   if(response.data.successvar==1){        

      document.getElementById("delete-card").style.display="none";
      document.getElementById("delete-success-card").style.display="block";  
      sessionStorage.removeItem("DEditId");

  }
  
      //Cannot Delete Counter
    else{  
    document.getElementById("delete-card").style.display="none";
    document.getElementById("delete-error-card").style.display="block";   }
  

});
}
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("DEditId00");


   window.location.replace("/");
 
  }
 
 }
  
 //******************* DELETE CUSTOMER FUNCTION END ********************//




    
//******************* GET EXCEL DATA FUNCTION START  ********************//
function getexcelData(){
 

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))){
 

   const $filter_lead_stage = filter_lead_stage; const $filter_customer_name = filter_customer_name; const $filter_email = filter_email; const $filter_contact = filter_contact; const $filter_lead_date = filter_lead_date;
   const $filter_lead_status = filter_lead_status; const $filter_loan_requirement = filter_loan_requirement; const $filter_source = filter_source;

 axios.post("loancrm-get-leads-list-inexcel", {
   Log_id:logid,
   Token:token,
 //  Busy_id:busyid,
 //  Counter_id:counterid,
   Sn_start :0,
   Sn_end :0,
   Sn_total :0,
   Sn_limit :0,
   Filter_val : filter_val,
   Filter_lead_stage : $filter_lead_stage,
   Filter_customer_name : $filter_customer_name,
   Filter_email : $filter_email,
   Filter_contact : $filter_contact,
   Filter_lead_date : $filter_lead_date,
   Filter_lead_status : $filter_lead_status,
   Filter_loan_requirement : $filter_loan_requirement,
   Filter_source : $filter_source,
   
   //Code Edits for pagination
   'page' : pageNumber


   })
 .then((response) => {


  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");

     window.location.replace("/");
  }
  //Success Data Fetched
      if(response.data.successvar==1){
        //Setting Data
      const exceldata =response.data.data;
       
      // Convert JSON data to Excel worksheet
      const worksheet = XLSX.utils.json_to_sheet(exceldata);
      
      // Create a new workbook and add the worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      
      // Convert the workbook to a binary array
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      
      // Create a Blob from the binary data and trigger a download
      const excel_data = new Blob([excelBuffer], { type: "application/octet-stream" });
      saveAs(excel_data, "data.xlsx");
     }
     //Cannot Fetch Data
     else{
       seterrorvar("Cannot Download Excel File !");
     }   
   
 
 });
 
 }
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");


   window.location.replace("/");
 
  }
 
 }
  
 //******************* GET EXCEL DATA FUNCTION END  ********************//


 



return(
    <>
<html lang="en">
  <head>
    {/*} Required meta tags */}
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
    <title>BUSINESS SAMADHAN | Loan CRM</title>
    {/*} plugins:css */}
    <link rel="stylesheet" href="panel/assets/vendors/mdi/css/materialdesignicons.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/flag-icon-css/css/flag-icon.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/css/vendor.bundle.base.css" />
    {/*} endinject */}
    {/*} Plugin css for this page */}
    <link rel="stylesheet" href="panel/assets/vendors/jquery-bar-rating/css-stars.css" />
    <link rel="stylesheet" href="panel/assets/vendors/font-awesome/css/font-awesome.min.css" />
    {/*} End plugin css for this page */}
    {/*} inject:css */}
    {/*} endinject */}
    {/*} Layout styles */}
    <link rel="stylesheet" href="panel/assets/css/demo_1/style.css" />
    {/*} End layout styles */}
    <link rel="shortcut icon" href="panel/assets/images/favicon.png" />
  </head>
  <body>


    <div class="container-scroller">

      <Sidebar />
    <div class="container-fluid page-body-wrapper">




       <Navbar />
        {/*} partial */}
        <div class="main-panel">


              
          

          <div class="content-wrapper pb-0">

          
        {/*} table row starts here 
        <div class="row">
             
             <div class="card stretch-card mb-3 col-md-3">
               <div class="card-body d-flex flex-wrap justify-content-between">
                 <div>
                   <h4 class="font-weight-semibold mb-1 text-black"> Products </h4>
                   <h6 class="text-muted">products listed on site</h6>
                 </div>
                 <h3 class="text-primary font-weight-bold">168</h3>
               </div>
             </div>
             <div class="card stretch-card mb-3 col-md-3">
               <div class="card-body d-flex flex-wrap justify-content-between">
                 <div>
                   <h4 class="font-weight-semibold mb-1 text-black"> Trainings </h4>
                   <h6 class="text-muted">trainings listed on site</h6>
                 </div>
                 <h3 class="text-primary font-weight-bold">689</h3>
               </div>
             </div>
             <div class="card mb-3 col-md-3">
               <div class="card-body d-flex flex-wrap justify-content-between">
                 <div>
                   <h4 class="font-weight-semibold mb-1 text-black"> Orders </h4>
                   <h6 class="text-muted">orders received on site</h6>
                 </div>
                 <h3 class="text-primary font-weight-bold">838</h3>
               </div>
             </div>
             <div class="card mb-3 col-md-3">
               <div class="card-body d-flex flex-wrap justify-content-between">
                 <div>
                   <h4 class="font-weight-semibold mb-1 text-black"> Applications </h4>
                   <h6 class="text-muted">applications received on site</h6>
                 </div>
                 <h3 class="text-primary font-weight-bold">838</h3>
               </div>
             </div>

           </div>
            table row end here */}

             {/* CREATE TEAM FORM START */}
                    <div class="row">
                        <div class="col-12 grid-margin create-form" id="create-form">
                    {/*}   <Newcrm_addcustomer /> */}
                    
                        </div>
                    </div>
            {/* CREATE TEAM FORM END */}

          
            <div class="page-header flex-wrap">
            <div class="header-left"></div>
              <div class="header-right d-flex flex-wrap mt-2 mt-sm-0">
                <div class="d-flex align-items-center">
                  <a href="#">
                    <p class="m-0 pe-3">CUSTOMERS - LOAN ENQUIRY</p>
                  </a>
                  <a class="ps-3 me-4" href="#">
                    <p class="m-0"></p>
                  </a>
                </div>
            {/*}   <a href="/loanenquiry-form"> <button type="button" class="btn btn-primary mt-2 mt-sm-0 btn-icon-text" >
                  <i class="mdi mdi-plus-circle"></i> Add New Customer</button></a> */}
              
              </div>
            </div>


            {/* CUSTOMER DETAILS TABLE START */}
                  
             <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                {/*}    <h4 class="card-title">Customers</h4>
                    <p class="card-description">view customer details
                    </p>*/}


                             {/* FILTER SECTION START */}
                             <hr/>
                            <div id="filter-top-card" class="row col-12" style={{textAlign:"left",display:"none"}}>
                            <div class="d-flex justify-content-between">
                            <div>
                            <h4 style={{padding:'1rem'}}>Filters</h4>
                           </div>
                           <div>
                    
                           <button type="button" class="btn btn-social-icon" onClick={()=>{ document.getElementById("filter-top-card").style.display="none"; }}>
                           <i class="mdi mdi-close-box text-danger" style={{fontSize:"2rem"}}></i>
                           </button>
                           </div>
                           </div>
        
                        <div class="row">
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Lead Stage</label>
                            <div class="col-sm-9">
                              <select class="form-control" placeholder="121" id="filter_lead_stage" style={{padding:"1rem"}} value={filter_lead_stage} onChange={updatefilter_lead_stage}  >
                              <option value=" ">All</option>
                              <option value="new enquiry">new enquiry</option>
                              <option value="requested documents">requested documents</option>
                              <option value="documents verification under process">documents verification under process</option>
                              <option value="applied for loan">applied for loan</option>
                              <option value="under review">under review</option>
                              <option value="rejected">rejected</option>
                              <option value="on hold">on hold</option>
                              <option value="approved">approved</option>
                              </select>
                              <code>{filter_lead_stage_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Customer Name</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="Rakesh Sharma" value={filter_customer_name} onChange={updatefilter_customer_name}  />
                              <code>{filter_customer_name_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Email</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="rakeshsharma123@gmail.com"  value={filter_email} onChange={updatefilter_email}  />
                              <code>{filter_email_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Contact</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="9414444410" value={filter_contact} onChange={updatefilter_contact}  />
                              <code>{filter_contact_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Lead Date</label>
                            <div class="col-sm-9">
                              <input type="date" class="form-control" placeholder="9414444100"  value={filter_lead_date} onChange={updatefilter_lead_date}  />
                              <code>{filter_lead_date_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Lead Status</label>
                            <div class="col-sm-9">
                              <select class="form-control" value={filter_lead_status} style={{padding:"1rem"}} onChange={updatefilter_lead_status}  >
                              <option value=" ">All</option>
                              <option value="active">active</option>
                              <option value="not responding">not responding</option>
                              <option value="closed">closed</option>
                              <option value="poor lead">poor lead</option>
                              </select>
                              <code>{filter_lead_status_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Source</label>
                            <div class="col-sm-9">
                              <select class="form-control" value={filter_source} style={{padding:"1rem"}} onChange={updatefilter_source}  >
                              <option value=" ">All</option>
                              <option value="Business Samadhan">Business Samadhan</option>
                              <option value="Rojgar Bandhu">Rojgar Bandhu</option>
                              </select>
                              <code>{filter_source_er}</code>
                            </div>
                          </div>
                        </div>
                      
                    {/*}  <div class="row">
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">City</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="Ahmedabad" value={filter_city} onChange={updatefilter_city}  />
                              <code>{filter_city_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">State</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="Gujarat"  value={filter_state} onChange={updatefilter_state}  />
                              <code>{filter_state_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Country</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="India" value={filter_country} onChange={updatefilter_country}  />
                              <code>{filter_country_er}</code>
                            </div>
                          </div>
                        </div>
                      </div> */}
                    {/*}  <div class="row">
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Type</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="Regular" value={filter_type} onChange={updatefilter_type}  />
                              <code>{filter_type_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Category</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="Offline"  value={filter_category} onChange={updatefilter_category}  />
                              <code>{filter_category_er}</code>
                            </div>
                          </div>
                        </div> 
                        </div>*/}
                        <div class="col-md-4">
                         <button class="btn btn-primary" onClick={()=>{ setfilter_val(1); getData(); }}>Apply Filters</button>
                         <button class="btn btn-danger" style={{marginLeft:"1rem"}} onClick={()=>{ setfilter_val(0); getData(); }}>Remove Filters</button>
                        </div>
                        <br/>
                        <br/>
                      </div>
                            <hr/>                      
                            </div>
                            
                            {/* FILTER SECTION END */}

                  <div class="col-12" style={{marginBottom:"2rem"}}>
                        <div class="template-demo d-flex justify-content-between">
                        <div><a href="https://www.businesssamadhan.in/businesssamadhan-loanenquiry-form" class="btn btn-outline-danger">Business Samadhan</a>
                       <a href="https://www.thestartupconnect.com/rojgarbandhu-loanenquiry-form" class="btn btn-outline-primary ml-2">Rojgar Bandhu</a></div>

                        {/* COLUMNS MANAGEMENT DROPDOWN START */}
                       
                          <div class="dropdown">
                           <button class="btn btn-warning" onClick={()=>{ document.getElementById("filter-top-card").style.display="block"; }}><i class="mdi mdi-filter-outline"></i></button>
                          
                         {/*}   <button class="btn btn-primary dropdown-toggle" style={{marginLeft:"1rem"}} type="button" id="dropdownMenuIconButton1" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="mdi mdi-table-large"></i>
                            </button>     */}

                            <div class="dropdown-menu" aria-labelledby="dropdownMenuIconButton1">
                              <h6 class="dropdown-header">Columns</h6>
                              <hr/>
                              
                              {/* Column 1 */}
                              <li><div class="d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Cid</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c1_yes" onClick={()=>{setcd_col1_val(1); document.getElementById("cd_c1_yes").style.display="none"; document.getElementById("cd_c1_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c1_no" style={{ display:"none"}} onClick={()=>{ setcd_col1_val(0); document.getElementById("cd_c1_yes").style.display="block"; document.getElementById("cd_c1_no").style.display="none"; }}></i>
                              </div></div></li> 
                               {/* Column 2 */}
                               <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Cudtomer Id</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c2_yes"  onClick={()=>{setcd_col2_val(1); document.getElementById("cd_c2_yes").style.display="none"; document.getElementById("cd_c2_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c2_no" style={{ display:"none"}} onClick={()=>{ setcd_col2_val(0); document.getElementById("cd_c2_yes").style.display="block"; document.getElementById("cd_c2_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 3 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">First Name</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c3_yes"  onClick={()=>{setcd_col3_val(1); document.getElementById("cd_c3_yes").style.display="none"; document.getElementById("cd_c3_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c3_no" style={{ display:"none"}} onClick={()=>{ setcd_col3_val(0); document.getElementById("cd_c3_yes").style.display="block"; document.getElementById("cd_c3_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 4 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Last Name</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c4_yes"  onClick={()=>{setcd_col4_val(1); document.getElementById("cd_c4_yes").style.display="none"; document.getElementById("cd_c4_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c4_no" style={{ display:"none"}} onClick={()=>{ setcd_col4_val(0); document.getElementById("cd_c4_yes").style.display="block"; document.getElementById("cd_c4_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 5 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Email</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c5_yes"  onClick={()=>{setcd_col5_val(1); document.getElementById("cd_c5_yes").style.display="none"; document.getElementById("cd_c5_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c5_no" style={{ display:"none"}} onClick={()=>{ setcd_col5_val(0); document.getElementById("cd_c5_yes").style.display="block"; document.getElementById("cd_c5_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 6 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Contact</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c6_yes"  onClick={()=>{setcd_col6_val(1); document.getElementById("cd_c6_yes").style.display="none"; document.getElementById("cd_c6_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c6_no" style={{ display:"none"}} onClick={()=>{ setcd_col6_val(0); document.getElementById("cd_c6_yes").style.display="block"; document.getElementById("cd_c6_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 7 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">WhatsApp</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c7_yes" onClick={()=>{setcd_col7_val(1); document.getElementById("cd_c7_yes").style.display="none"; document.getElementById("cd_c7_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c7_no" style={{ display:"none"}} onClick={()=>{ setcd_col7_val(0); document.getElementById("cd_c7_yes").style.display="block"; document.getElementById("cd_c7_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 8 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Type</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c8_yes" onClick={()=>{setcd_col8_val(1); document.getElementById("cd_c8_yes").style.display="none"; document.getElementById("cd_c8_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c8_no" style={{ display:"none"}} onClick={()=>{ setcd_col8_val(0); document.getElementById("cd_c8_yes").style.display="block"; document.getElementById("cd_c8_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 9 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Category</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c9_yes" onClick={()=>{setcd_col9_val(1); document.getElementById("cd_c9_yes").style.display="none"; document.getElementById("cd_c9_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c9_no" style={{ display:"none"}} onClick={()=>{ setcd_col9_val(0); document.getElementById("cd_c9_yes").style.display="block"; document.getElementById("cd_c9_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 10 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Status</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c10_yes" onClick={()=>{setcd_col10_val(1); document.getElementById("cd_c10_yes").style.display="none"; document.getElementById("cd_c10_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c10_no" style={{ display:"none"}} onClick={()=>{ setcd_col10_val(0); document.getElementById("cd_c10_yes").style.display="block"; document.getElementById("cd_c10_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 11 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">City</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c11_yes" onClick={()=>{setcd_col11_val(1); document.getElementById("cd_c11_yes").style.display="none"; document.getElementById("cd_c11_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c11_no" style={{ display:"none"}} onClick={()=>{ setcd_col11_val(0); document.getElementById("cd_c11_yes").style.display="block"; document.getElementById("cd_c11_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/*} Column 12 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Last Updated</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c12_yes" onClick={()=>{setcd_col12_val(1); document.getElementById("cd_c12_yes").style.display="none"; document.getElementById("cd_c12_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c12_no" style={{ display:"none"}} onClick={()=>{ setcd_col12_val(0); document.getElementById("cd_c12_yes").style.display="block"; document.getElementById("cd_c12_no").style.display="none"; }}></i>
                              </div></div></li>  
                             {/* Column 13 
                             <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Date Created</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c13_yes" onClick={()=>{setcd_col13_val(1); document.getElementById("cd_c13_yes").style.display="none"; document.getElementById("cd_c13_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c13_no" style={{ display:"none"}} onClick={()=>{ setcd_col13_val(0); document.getElementById("cd_c13_yes").style.display="block"; document.getElementById("cd_c13_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 14 
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Date Updated</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c14_yes" onClick={()=>{setcd_col14_val(1); document.getElementById("cd_c14_yes").style.display="none"; document.getElementById("cd_c14_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c14_no" style={{ display:"none"}} onClick={()=>{ setcd_col14_val(0); document.getElementById("cd_c14_yes").style.display="block"; document.getElementById("cd_c14_no").style.display="none"; }}></i>
                              </div></div></li> 
                             {/* Column 15 
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Steam Status</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c15_yes" onClick={()=>{setcd_col15_val(1); document.getElementById("cd_c15_yes").style.display="none"; document.getElementById("cd_c15_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c15_no" style={{ display:"none"}} onClick={()=>{ setcd_col15_val(0); document.getElementById("cd_c15_yes").style.display="block"; document.getElementById("cd_c15_no").style.display="none"; }}></i>
                              </div></div></li> 
                             {/* Column 16 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Edit</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c16_yes" onClick={()=>{setcd_col16_val(1); document.getElementById("cd_c16_yes").style.display="none"; document.getElementById("cd_c16_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c16_no" style={{ display:"none"}} onClick={()=>{ setcd_col16_val(0); document.getElementById("cd_c16_yes").style.display="block"; document.getElementById("cd_c16_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 17 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10 text-warning">Delete</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c17_yes" onClick={()=>{setcd_col17_val(1); document.getElementById("cd_c17_yes").style.display="none"; document.getElementById("cd_c17_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c17_no" style={{ display:"none"}} onClick={()=>{ setcd_col17_val(0); document.getElementById("cd_c17_yes").style.display="block"; document.getElementById("cd_c17_no").style.display="none"; }}></i>
                              </div></div></li> 
                            
                            {/*}  <div class="dropdown-divider"></div>
                              <button class="btn btn-danger">Close</button>*/}
                            </div> 
                          </div>
                          {/* COLUMNS MANAGEMENT DROPDOWN END */}

                          </div>
                          </div>


                    <div class="table-responsive"  id="reports" ref={componentRef}>
                      <table class="table table-hover">
                        <thead>
                          <tr >
                            <th  style={{fontWeight:"bold"}}>Manage Lead</th> 
                            <th  style={{fontWeight:"bold"}} id="cd_c1" hidden={cd_col1_val==1}>Logins</th> 
                            <th  style={{fontWeight:"bold"}} id="cd_c1" hidden={cd_col1_val==1}>Lead Id</th> 
                            <th  style={{fontWeight:"bold"}} id="cd_c2" hidden={cd_col2_val==1}>Customer Name</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c3" hidden={cd_col3_val==1}>Contact</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c4" hidden={cd_col4_val==1}>Loan Requirement</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c5" hidden={cd_col5_val==1}>Lead Stage</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c6" hidden={cd_col6_val==1}>Lead Status</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c7" hidden={cd_col7_val==1}>Customer Type</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c8" hidden={cd_col8_val==1}>Lead Type</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c9" hidden={cd_col9_val==1}>Email</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c10" hidden={cd_col10_val==1}>Whatsapp</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c11" hidden={cd_col11_val==1}>Address</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c11" hidden={cd_col11_val==1}>City</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c11" hidden={cd_col11_val==1}>State</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c11" hidden={cd_col11_val==1}>Received</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c12" hidden={cd_col12_val==1}>Last Updated</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c12" hidden={cd_col12_val==1}>Source</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c12" hidden={cd_col12_val==1}>Updated By</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c12" hidden={cd_col12_val==1}>Lead Remarks</th>
                           {/*} <th  style={{fontWeight:"bold"}} id="cd_c13" hidden={cd_col13_val==1}></th>
                            <th  style={{fontWeight:"bold"}} id="cd_c14" hidden={cd_col14_val==1}></th>
                            <th  style={{fontWeight:"bold"}} id="cd_c15" hidden={cd_col15_val==1}>Steam_status</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c16" hidden={cd_col16_val==1}>Last Updated</th> 
                            <th  style={{fontWeight:"bold"}} id="cd_c16" hidden={cd_col16_val==1}></th> 
                            <th  style={{fontWeight:"bold"}} id="cd_c17" hidden={cd_col17_val==1}></th> */}
                          </tr>
                        </thead>
                        <tbody>
                        {
                       data.map((curElm,ind)=>{

                         return(
                         <>
                       
                        <tr key={curElm.Cid}>
                            <td id="cd_co1"><i class="mdi mdi-assistant text-warning" style={{fontSize:"1.4rem", cursor:"pointer"}} onClick={()=>{
                              //Setting Customer Id and Redirect to Create Leads Form
                               sessionStorage.setItem("EditId00",curElm.Lead_id);
                               window.location.replace("loancrm-manage-lead");

                            }}></i></td> 
                             <td id="cd_co1"><button class="btn btn-primary" onClick={()=>{
                              //Setting Customer Id and Redirect to Create Leads Form
                               sessionStorage.setItem("EditId00",curElm.Lead_id);
                               window.location.replace("loancrm-loanlogins");

                            }}>logins</button></td> 
                            <td id="cd_co1"  hidden={cd_col1_val==1}>{curElm.Lead_id}</td> 
                            <td id="cd_co2"  hidden={cd_col2_val==1}>{curElm.Customer_name}</td>
                            <td id="cd_co3"  hidden={cd_col3_val==1}>{curElm.Contact}</td>
                            <td id="cd_co4"  hidden={cd_col4_val==1}>{curElm.Loan_requirement}</td>
                            <td id="cd_co5"  hidden={cd_col5_val==1}>
                            <label class="badge badge-secondary" hidden={(curElm.Lead_stage=="requested documents")||(curElm.Lead_stage=="documents verification under process")||(curElm.Lead_stage=="applied for loan")||(curElm.Lead_stage=="under review")||(curElm.Lead_stage=="rejected")||(curElm.Lead_stage=="on hold")||((curElm.Lead_stage=="approved"))}>new enquiry</label>
                            <label class="badge badge-info" hidden={(curElm.Lead_stage=="new enquiry")||(curElm.Lead_stage=="documents verification under process")||(curElm.Lead_stage=="applied for loan")||(curElm.Lead_stage=="under review")||(curElm.Lead_stage=="rejected")||(curElm.Lead_stage=="on hold")||((curElm.Lead_stage=="approved"))}>requested documents</label>
                            <label class="badge badge-info" hidden={(curElm.Lead_stage=="new enquiry")||(curElm.Lead_stage=="requested documents")||(curElm.Lead_stage=="applied for loan")||(curElm.Lead_stage=="under review")||(curElm.Lead_stage=="rejected")||(curElm.Lead_stage=="on hold")||((curElm.Lead_stage=="approved"))}>documents verification <br/> under process</label>
                            <label class="badge badge-primary" hidden={(curElm.Lead_stage=="new enquiry")||(curElm.Lead_stage=="documents verification under process")||(curElm.Lead_stage=="requested documents")||(curElm.Lead_stage=="under review")||(curElm.Lead_stage=="rejected")||(curElm.Lead_stage=="on hold")||((curElm.Lead_stage=="approved"))}>applied for loan</label>
                            <label class="badge badge-warning" hidden={(curElm.Lead_stage=="new enquiry")||(curElm.Lead_stage=="documents verification under process")||(curElm.Lead_stage=="applied for loan")||(curElm.Lead_stage=="requested documents")||(curElm.Lead_stage=="rejected")||(curElm.Lead_stage=="on hold")||((curElm.Lead_stage=="approved"))}>under review</label>
                            <label class="badge badge-danger" hidden={(curElm.Lead_stage=="new enquiry")||(curElm.Lead_stage=="documents verification under process")||(curElm.Lead_stage=="applied for loan")||(curElm.Lead_stage=="requested documents")||(curElm.Lead_stage=="under review")||(curElm.Lead_stage=="on hold")||((curElm.Lead_stage=="approved"))}>rejected</label>
                            <label class="badge badge-success" hidden={(curElm.Lead_stage=="new enquiry")||(curElm.Lead_stage=="documents verification under process")||(curElm.Lead_stage=="applied for loan")||(curElm.Lead_stage=="requested documents")||(curElm.Lead_stage=="under review")||(curElm.Lead_stage=="on hold")||((curElm.Lead_stage=="rejected"))}>approved</label>     
                            <label class="badge badge-dark" hidden={(curElm.Lead_stage=="new enquiry")||(curElm.Lead_stage=="documents verification under process")||(curElm.Lead_stage=="applied for loan")||(curElm.Lead_stage=="requested documents")||(curElm.Lead_stage=="under review")||(curElm.Lead_stage=="rejected")||((curElm.Lead_stage=="approved"))}>on hold</label>         
                            </td>
                            <td id="cd_co6"  hidden={cd_col6_val==1}>
                            <label className="badge badge-danger" hidden={(curElm.Lead_status=="active")||(curElm.Lead_status=="not responding")||(curElm.Lead_status=="closed")}>poor lead</label>
                            <label className="badge badge-primary" hidden={(curElm.Lead_status=="active")||(curElm.Lead_status=="not responding")||(curElm.Lead_status=="poor lead")}>closed</label>
                            <label className="badge badge-success" hidden={(curElm.Lead_status=="poor lead")||(curElm.Lead_status=="not responding")||(curElm.Lead_status=="closed")}>active</label>
                            <label className="badge badge-dark" hidden={(curElm.Lead_status=="active")||(curElm.Lead_status=="poor lead")||(curElm.Lead_status=="closed")}>not responding</label>
                            </td>
                            <td id="cd_co7"  hidden={cd_col7_val==1}>{curElm.Customer_type}</td>
                            <td id="cd_co8"  hidden={cd_col8_val==1}>{curElm.Lead_type}</td>
                            <td id="cd_co9"  hidden={cd_col9_val==1}>{curElm.Email}</td>
                            <td id="cd_co9"  hidden={cd_col9_val==1}>{curElm.Whatsapp}</td>
                            <td id="cd_co9"  hidden={cd_col9_val==1}>{curElm.Address}</td>
                            <td id="cd_co9"  hidden={cd_col9_val==1}>{curElm.City}</td>
                            <td id="cd_co9"  hidden={cd_col9_val==1}>{curElm.State}</td>
                           {/*} <td id="cd_co10"  hidden={cd_col10_val==1}>
                            <label className="badge badge-danger" hidden={curElm.Customer_status=="active"}>inactive</label>
                            <label className="badge badge-success" hidden={curElm.Customer_status=="inactive"}>active</label>
                            </td> */}
                         {/* <td id="cd_co11"  hidden={cd_col11_val==1}>{curElm.City}</td> */}
                            <td id="cd_co12"  hidden={cd_col12_val==1}>{curElm.Date_created}<br/> ({curElm.Time_created})</td>
                            <td id="cd_co12"  hidden={cd_col12_val==1}>{curElm.Date_updated}<br/> ({curElm.Time_updated})</td>
                            <td id="cd_co9"  hidden={cd_col9_val==1}>{curElm.Source}</td>
                            <td id="cd_co9"  hidden={cd_col9_val==1}>{curElm.Updated_by}</td>
                            <td id="cd_co9"  hidden={cd_col9_val==1}>{curElm.Lead_remarks}</td>
                          
                      {/*}      <td id="cd_co17"  hidden={cd_col17_val==1}><i class="mdi mdi-delete-forever text-danger" style={{fontSize:"1.4rem"}} onClick={()=>{ 
                            //Setting Customer Id for Delete
                            sessionStorage.setItem("DEditId00",curElm.Cid);  document.getElementById('delete-card').style.display = 'block'; }}></i></td> */}
                           </tr>
                          </>
                         )
                         }
                       
                             )
                         }
                       
                         
                        </tbody>
                      </table>
                    </div> 














                        {/* PAGINATION SECTION START */}
                        <div>
                       <div class="col-12" style={{marginBottom:"2rem",marginTop:"1rem"}}>
                        <div class="template-demo d-flex justify-content-between">
                        <div></div>

                       
                          <div class="dropdown">
                          <button class="btn" onClick={()=>{ const pgNumber=pageNumber-1; setpageNumber(pgNumber); getData();  }}><i class="mdi mdi-arrow-left-drop-circle text-success"></i></button>
                          <button class="btn" onClick={()=>{ const pgNumber=pageNumber+1; setpageNumber(pgNumber); getData();  }}><i class="mdi mdi-arrow-right-drop-circle text-success"></i></button>
                          </div>
                          </div>
                          </div>
                    </div>
                    {/* PAGINATION SECTION END */}

                    <button class="btn btn-light" onClick={handlePrint}><i class="mdi mdi-cloud-print text-dark"></i></button>
                    <button class="btn btn-light" onClick={getexcelData}><i class="mdi mdi-file-excel text-dark"></i></button>

                   
                   
                  </div>
                </div>
              </div>
              {/* CUSTOMER DETAILS TABLE END */}


            
          </div>
          {/*} content-wrapper ends */}
          {/*} partial:partials/_footer.html */}
         {/*} <footer class="footer">
            <div class="d-sm-flex justify-content-center justify-content-sm-between">
              <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2021 <a href="https://www.bootstrapdash.com/" target="_blank">BootstrapDash</a>. All rights reserved.</span>
              <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted & made with <i class="mdi mdi-heart text-danger"></i></span>
            </div>
          </footer> */}
          {/*} partial */}
        </div>
        {/*} main-panel ends */}
      </div>
      {/*} page-body-wrapper ends */}
    </div>
    {/*} container-scroller */}
    {/*} plugins:js */}
    <script src="panel/assets/vendors/js/vendor.bundle.base.js"></script>
    {/*} endinject */}
    {/*} Plugin js for this page */}
    <script src="panel/assets/vendors/jquery-bar-rating/jquery.barrating.min.js"></script>
    <script src="panel/assets/vendors/chart.js/Chart.min.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.resize.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.categories.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.fillbetween.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.stack.js"></script>
    <script src="panel/assets/js/jquery.cookie.js" type="text/javascript"></script>
    {/*} End plugin js for this page */}
    {/*} inject:js */}
    <script src="panel/assets/js/off-canvas.js"></script>
    <script src="panel/assets/js/hoverable-collapse.js"></script>
    <script src="panel/assets/js/misc.js"></script>
    <script src="panel/assets/js/settings.js"></script>
    <script src="panel/assets/js/todolist.js"></script>
    {/*} endinject */}
    {/*} Custom js for this page */}
    <script src="panel/assets/js/dashboard.js"></script>
    {/*} End custom js for this page */}
  </body>
</html>
</>
);


//}
}
export default Loancrm_customerslist;